import { useEffect } from 'react';

import { DontExistsItem } from '../../../components/DontExistsItem';
import { DontExistsItemFlex } from '../../../components/DontExistsItem/styles';
import { ListLines } from '../../../components/List/ListLines';
import { LoadingData } from '../../../components/LoadingData';
import { InfoLine } from '../../../components/Modal/InfoLine';
import { PageHeader } from '../../../components/PageHeader';
import { Paginator } from '../../../components/Paginator';
import { useLineContext } from '../../../context/ProviderPage/Linha';
import { usePageContext } from '../../../context/usePage';
import { ContainerPage, PageContent } from '../../../styles/global.styles';

const Linha = () => {
  const { setSelectedPage } = usePageContext();

  const {
    loadingLine,
    loadLineAction,
    line,
    openSideModalFilterLineAction,
    openInfo,
    setOpenInfo,
    setOfsset,
    limit,
    offset,
    quantity,
    page,
    setPage,
    setHasClick,
    start,
    setStart,
  } = useLineContext();

  useEffect(() => {
    setSelectedPage({ option: 'linha' });
    loadLineAction();
  }, []);

  return (
    <>
      <PageHeader
        pageIcon={{ option: 'linha' }}
        pageTitle="Linha"
        filterAction={openSideModalFilterLineAction}
      />

      <ContainerPage>
        <PageContent
          style={{
            justifyContent: `${
              loadingLine === true ? 'center' : 'space-between'
            }`,
          }}
        >
          {loadingLine ? (
            <LoadingData title="Buscando dados" />
          ) : (
            <>
              {line.length === 0 ? (
                <DontExistsItemFlex>
                  <DontExistsItem title="Nenhuma linha foi encontrada!" />
                </DontExistsItemFlex>
              ) : (
                <>
                  <ListLines data={line} />
                  <Paginator
                    {...{
                      start,
                      setStart,
                      limitItens: limit,
                      offset,
                      page,
                      quantity,
                      setHasClick,
                      setOfsset,
                      setPage,
                      quantityShowed: line.length,
                    }}
                  />
                </>
              )}
            </>
          )}
        </PageContent>
        <InfoLine
          option="linha"
          titleModal="Linha selecionada"
          isOpen={openInfo}
          closeModal={setOpenInfo}
        />
      </ContainerPage>
    </>
  );
};

export { Linha };
